<!-- Confirm Dialog -->
@if (isOpen) {
<div
  class="fixed inset-0 z-[9999] overflow-y-auto"
  role="dialog"
  aria-modal="true"
  aria-labelledby="confirm-dialog-title"
>
  <!-- Backdrop with fade animation -->
  <div
    class="fixed inset-0 bg-gray-900/60 backdrop-blur-sm animate-backdrop-enter"
    (click)="onBackdropClick($event)"
  ></div>

  <!-- Dialog Container -->
  <div class="flex min-h-full items-center justify-center p-4">
    <!-- Dialog Panel -->
    <div
      class="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white shadow-2xl animate-dialog-enter"
      (click)="$event.stopPropagation()"
    >
      <!-- Close Button -->
      @if (showCloseButton && !loading) {
      <button
        type="button"
        class="absolute right-4 top-4 rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300"
        (click)="cancel()"
        aria-label="Close dialog"
      >
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      }

      <!-- Dialog Content -->
      <div class="px-6 pt-8 pb-6">
        <!-- Icon -->
        <div class="flex justify-center mb-5">
          <div [ngClass]="iconContainerClass">
            @switch (type) {
              @case ('danger') {
                <!-- Trash Icon -->
                <svg class="h-7 w-7" [ngClass]="iconClass" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                </svg>
              }
              @case ('success') {
                <!-- Check Icon -->
                <svg class="h-7 w-7" [ngClass]="iconClass" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              }
              @case ('info') {
                <!-- Info Icon -->
                <svg class="h-7 w-7" [ngClass]="iconClass" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
              }
              @default {
                <!-- Warning Icon -->
                <svg class="h-7 w-7" [ngClass]="iconClass" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                </svg>
              }
            }
          </div>
        </div>

        <!-- Text Content -->
        <div class="text-center">
          <h3
            id="confirm-dialog-title"
            class="text-xl font-bold text-gray-900 mb-2"
          >
            {{ title }}
          </h3>
          <p class="text-sm text-gray-500 leading-relaxed">
            {{ message }}
          </p>
        </div>
      </div>

      <!-- Dialog Actions -->
      <div class="px-6 pb-6 pt-2 flex flex-col-reverse sm:flex-row sm:justify-center gap-3">
        <button
          type="button"
          [ngClass]="cancelButtonClass"
          (click)="cancel()"
          [disabled]="loading"
        >
          {{ cancelText }}
        </button>
        <button
          type="button"
          [ngClass]="confirmButtonClass"
          (click)="confirm()"
          [disabled]="loading"
        >
          @if (loading) {
            <svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          }
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</div>
}
